/*
 * @Author: etong
 * @Date: 2021-02-26 10:18:43
 * @LastEditTime: 2021-07-30 16:42:41
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\views\activitySetpriceManagement\activityDetail.js
 * @Think first, Program later
 */
const activityDetail = {
  state: {
    activityFormdata: {}, // 表单
    mainProduct: [], // 主商品/单品促销商品数据源 （添加商品 商品表选择数据）
    msMainProduct: [], // 满送主商品
    productTabObj: {}, // 标签页 创建统一的数据源
    msMainGroupProduct: [], // 主商品套装
    msMainGroupProductSku: [], // 主商品套装明细
    filterObj: [], // 已选择的商品编码
    msGiftProduct: [], // 满送赠品
    msGiftGroupProduct: [], // 满送赠品套装
    msGiftGroupProductSku: [], // 满送赠品套装明细
    productTabSelected: {}, // 用以记录满送标签页选中项记录
    chooseListProduct: {} // 选择的列表行数据
  },

  mutations: {
    // 设置活动提报表单数据
    SET_ACTIVITY_FORM_DATA: (state, data) => {
      state.activityFormdata = data
    },
    // 设置标签商品
    SET_FILTER_GOODS: (state, data) => {
      state.filterObj = data
    },
    // 设置单品促销主商品
    SET_MAIN_PRODUCT: (state, data) => {
      state.mainProduct = data
    },
    // 设置满送主商品
    SET_MS_MAIN_PRODUCT: (state, data) => {
      state.msMainProduct = data
    },
    // 设置主商品套装
    SET_MAIN_GROUP_PRODUCT: (state, data) => {
      state.msMainGroupProduct = data
    },
    // 设置主商品套装明细
    SET_MAIN_GROUP_PRODUCT_SKU: (state, data) => {
      state.msMainGroupProductSku = data
    },
    // 设置满送增品
    SET_MS_GIFT_PRODUCT: (state, data) => {
      state.msGiftProduct = data
    },
    // 设置满送赠品套装
    SET_MS_GIFT_GROUP_PRODUCT: (state, data) => {
      state.msGiftGroupProduct = data
    },
    // 设置满送赠品套装明细
    SET_MS_GIFT_GROUP_PRODUCT_SKU: (state, data) => {
      state.msGiftGroupProductSku = data
    },
    // 设置标签商品
    SET_TAB_PRODUCT: (state, data) => {
      state.productTabObj = data
    },
    // 设置标签商品选中项
    SET_TAB_PRODUCT_SELECTED: (state, data) => {
      const obj = Object.assign({}, data)
      state.productTabSelected = obj
    },
    // 选中的列表行数据
    CHOOSE_LIST_PRODUCT: (state, data) => {
      state.chooseListProduct = data
    }

  },

  actions: {

  }
}

export default activityDetail
